/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDisclosure } from "@jumbo/components/JumboDialog/hooks/useDisclosure";

import Stack from "@mui/material/Stack";
import {
  Button,
  Grid,
  InputAdornment,
  TextField,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import { Card, CardContent } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import Div from "@jumbo/shared/Div";
import Loader from "@jumbo/components/Loader";

import { usePagination } from "app/hooks/usePagination";
import { Table } from "app/components";
import { useDispatch, useSelector } from "react-redux";
import { userType } from "app/helpers/userType";
import { useNavigate, useParams } from "react-router-dom";

import { LoadingButton } from "@mui/lab";
import { useSnackbar } from "notistack";
import { Delete, Edit } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import { PRODUCTS_PROCESS_ADD } from "app/routes/constant";
import moment from "moment";
import DialogConfirm from "@jumbo/components/JumboDialog/components/DialogConfirm";
import DialogDefault from "@jumbo/components/JumboDialog/components/DialogDefault";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import JumboAutoComplete from "@jumbo/components/JumboAutoComplete";

import { getVariantList } from "app/redux/slice/variantSlice";
import { getSupplierList } from "app/redux/slice/supplierSlice";
import {
  deleteProductProcess,
  getProductProcessList,
  updateProductProcess,
} from "app/redux/slice/productSlice";

const ProductProcess = () => {
  const {
    isOpen: isEditOpen,
    onClose: closeEdit,
    stageAction,
    actionProps: editActionProps,
  } = useDisclosure();
  const dispatch = useDispatch();
  const { isMA } = userType();
  let { productId } = useParams();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const {
    isOpen: isDelete,
    onClose: closeDelete,
    actionProps: deleteActionProps,
    stageAction: deleteStageAction,
  } = useDisclosure();
  const productProcessData = useSelector((state) => state?.product);
  const productData = useSelector((state) => state?.product);
  const variantData = useSelector((state) => state?.variant);
  const supplierData = useSelector((state) => state?.supplier);

  const [searchText, setSearchText] = useState("");
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");
  const [filterType, setFilterType] = useState("all");

  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    usePagination({ id: "product-inward" });

  const [permissionData] = useState(
    JSON.parse(localStorage.getItem("permission")),
  );

  const [permission, setPermission] = useState({
    createPermission: false,
    updatePermission: false,
  });
  const getPermission = () => {
    if (isMA) {
      setPermission({
        createPermission: true,
        updatePermission: true,
      });
    } else {
      let permissionValue = {
        createPermission: false,
        updatePermission: false,
      };

      permissionData?.length &&
        permissionData.forEach(function (num) {
          if (num?.name === "create-product") {
            permissionValue.createPermission = true;
          }
          if (num?.name === "update-product") {
            permissionValue.updatePermission = true;
          }
        });
      setPermission(permissionValue);
    }
  };

  const handleFilterChange = (event, newFilter) => {
    if (newFilter !== null) {
      setFilterType(newFilter);
      handleChangePage(0, 0);
    }
  };

  const columns = [
    {
      id: "date",
      label: "Date",
      sort: true,
      render: (row) => moment(row?.date).format("DD-MM-YYYY"),
    },
    { id: "processNo", label: "Process No", sort: true },
    {
      id: "supplierId",
      label: "Supplier",
      render: (elm) => elm?.supplierId?.name,
    },
    {
      id: "productId",
      label: "Product Name",
      render: (elm) => elm?.productId?.name,
    },
    {
      id: "variantId",
      label: "Variant",
      render: (elm) => elm?.variantId?.name,
    },
    { id: "quantity", label: "Qty", sort: true },
    { id: "receivedQty", label: "Receive Qty", sort: true },
    { id: "pendingQty", label: "Pending Qty", sort: true },
    { id: "millName", label: "Mill Name", sort: true },
    {
      id: "challanNumber",
      label: "Challan No",
      sort: true,
    },
    { id: "lotNo", label: "Lot No", sort: true },
    {
      id: "performBy",
      label: "Perform By",
      render: (elm) => elm?.performBy?.name,
    },
    {
      id: "actions",
      label: "Actions",
      render: (row) => (
        <div>
          <IconButton
            disabled={!permission.updatePermission || row.receivedQty > 0}
            onClick={() => {
              stageAction(row);
            }}
          >
            <Edit />
          </IconButton>
          <IconButton
            onClick={() => {
              deleteStageAction(row);
            }}
            color="error"
            disabled={row.receivedQty > 0}
          >
            <Delete />
          </IconButton>
        </div>
      ),
      align: "right",
    },
  ];

  const getData = () => {
    localStorage.setItem("product-inward-search", searchText.trim());
    let value = {
      page: page,
      perPage: rowsPerPage,
      search: searchText.trim(),
      productId,
    };
    if (orderBy !== "") {
      value.sort = order === "asc" ? 1 : -1;
      value.field = orderBy;
    }
    if (filterType !== "all") value.type = filterType;
    dispatch(getProductProcessList(value));
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleChangePage(0, 0);
      getData();
    }
  };

  const sortData = (Order, OrderBy) => {
    setOrder(Order);
    setOrderBy(OrderBy);
  };
  const DeleteProduct = () => {
    closeDelete();
    dispatch(deleteProductProcess(deleteActionProps?._id))
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "success",
          });
          getData();
          closeDelete();
        } else {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "error",
          });
        }
      });
  };
  useEffect(() => {
    getPermission();
    // load product/variant/supplier lists for edit dialog
    // dispatch(getProductList({ sort: 1, field: "name" }));
    dispatch(getVariantList({ field: "name", sort: 1 }));
    dispatch(getSupplierList({ sort: 1, field: "name", type: "Knitter" }));
  }, []);

  useEffect(() => {
    getData();
  }, [page, rowsPerPage, dispatch, order, orderBy, filterType]);

  return (
    <>
      {productProcessData?.loading ? (
        <Loader />
      ) : (
        <>
          <Card sx={{ display: "flex", mb: 3 }}>
            <Div sx={{ display: "flex", flexDirection: "column", flex: "1" }}>
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Search"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyPress={handleKeyPress}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            style={{
                              display: searchText === "" ? "none" : "flex",
                            }}
                            onClick={() => setSearchText("")}
                          >
                            <ClearIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <ToggleButtonGroup
                      value={filterType}
                      exclusive
                      onChange={handleFilterChange}
                      aria-label="filter type"
                      fullWidth
                      size="small"
                    >
                      <ToggleButton value="all" aria-label="all items">
                        All
                      </ToggleButton>
                      <ToggleButton value="receive" aria-label="received items">
                        Receive
                      </ToggleButton>
                      <ToggleButton value="pending" aria-label="pending items">
                        Pending
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      onClick={() => {
                        handleChangePage(0, 0);
                        getData();
                      }}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Div>
          </Card>
          <Card>
            <CardContent>
              <Stack
                justifyContent="space-between"
                direction={{ xs: "column", sm: "row" }}
                sx={{ mb: 3 }}
              >
                <Typography variant={"h2"} mb={0}>
                  Product Process List
                </Typography>
                {permission.createPermission && (
                  <LoadingButton
                    onClick={() => {
                      navigate(PRODUCTS_PROCESS_ADD);
                    }}
                    type="submit"
                    variant="contained"
                  >
                    Add Product Process
                  </LoadingButton>
                )}
              </Stack>
              <Table
                columns={columns}
                rows={productProcessData?.listProcess}
                page={page}
                rowsPerPage={rowsPerPage}
                Order={order}
                count={productProcessData?.totalProcess}
                OrderBy={orderBy}
                sortData={sortData}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                editAction={stageAction}
              />
            </CardContent>
          </Card>
          <DialogDefault
            open={isEditOpen}
            onClose={closeEdit}
            content={
              <Formik
                initialValues={{
                  date: editActionProps?.date
                    ? new Date(editActionProps?.date)
                        .toISOString()
                        .split("T")[0]
                    : new Date().toISOString().split("T")[0],
                  supplierId: editActionProps?.supplierId ?? null,
                  challanNumber: editActionProps?.challanNumber ?? "",
                  productId: editActionProps?.productId ?? null,
                  variantId: editActionProps?.variantId ?? null,
                  quantity: editActionProps?.quantity ?? 0,
                  millName: editActionProps?.millName ?? "",
                  lotNo: editActionProps?.lotNo ?? "",
                }}
                enableReinitialize
                validationSchema={Yup.object({
                  date: Yup.date().required("Date is required"),
                  supplierId: Yup.object()
                    .nullable()
                    .required("Supplier is required"),
                  challanNumber: Yup.string().required(
                    "Challan number is required",
                  ),
                  quantity: Yup.number()
                    .nullable()
                    .typeError("Quantity must be a number")
                    .required("Please enter quantity")
                    .min(
                      editActionProps?.receivedQty,
                      `Quantity cannot be ${editActionProps?.receivedQty} or negative`,
                    )
                    .integer("Quantity must be a whole number"),
                  millName: Yup.string().required("Mill name is required"),
                  lotNo: Yup.string().required("Lot number is required"),
                })}
                onSubmit={async (values, { setSubmitting }) => {
                  setSubmitting(true);
                  const updateData = {
                    date: values.date,
                    supplierId: values?.supplierId?._id,
                    challanNumber: values.challanNumber,
                    quantity: values.quantity,
                    millName: values.millName,
                    lotNo: values.lotNo.trim(),
                  };
                  const response = await dispatch(
                    updateProductProcess({
                      id: editActionProps?._id,
                      data: updateData,
                    }),
                  ).unwrap();
                  if (response.status === 200) {
                    enqueueSnackbar(response.data?.responseMessage, {
                      variant: "success",
                    });
                    getData();
                    closeEdit();
                    setSubmitting(false);
                  } else {
                    enqueueSnackbar(response.data?.responseMessage, {
                      variant: "error",
                    });
                    setSubmitting(false);
                  }
                }}
              >
                {({ values, setFieldValue, isSubmitting, errors }) => (
                  <Form>
                    <div>
                      <Grid container spacing={3} mb={3}>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            fullWidth
                            name="date"
                            type="date"
                            label="Date*"
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) =>
                              setFieldValue("date", e.target.value)
                            }
                            value={values?.date}
                            error={errors?.date ? true : false}
                            helperText={errors?.date ?? ""}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <JumboAutoComplete
                            options={supplierData.list ?? []}
                            label="Supplier*"
                            size="large"
                            getOptionLabel={(option) => option?.name}
                            name="supplierId"
                            value={values?.supplierId}
                            onChange={(evt, value) => {
                              setFieldValue("supplierId", value);
                            }}
                            helperText={errors?.supplierId}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            fullWidth
                            name="challanNumber"
                            label="Challan Number*"
                            onChange={(e) =>
                              setFieldValue("challanNumber", e.target.value)
                            }
                            value={values?.challanNumber}
                            error={errors?.challanNumber ? true : false}
                            helperText={errors?.challanNumber ?? ""}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <JumboAutoComplete
                            options={productData.list ?? []}
                            label="Product"
                            size="large"
                            getOptionLabel={(option) => option?.name}
                            name={`productId`}
                            value={values?.productId}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <JumboAutoComplete
                            options={
                              values?.productId
                                ? variantData?.list?.filter(
                                    (list) =>
                                      list?.product?._id ===
                                      values?.productId?._id,
                                  ) || []
                                : []
                            }
                            label="Variant"
                            size="large"
                            getOptionLabel={(option) => option?.name}
                            name={`variantId`}
                            value={values?.variantId}
                            disabled
                          />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                          <TextField
                            fullWidth
                            name={`quantity`}
                            type="text"
                            label="Qty*"
                            onChange={(e) =>
                              setFieldValue(`quantity`, +e.target.value)
                            }
                            value={values?.quantity}
                            error={errors?.quantity ? true : false}
                            helperText={errors?.quantity ?? ""}
                          />
                        </Grid>
                        <Grid item xs={12} sm={5}>
                          <TextField
                            fullWidth
                            name={`millName`}
                            label="Mill Name"
                            onChange={(e) =>
                              setFieldValue(`millName`, e.target.value)
                            }
                            value={values?.millName}
                            error={errors?.millName ? true : false}
                            helperText={errors?.millName ?? ""}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            fullWidth
                            name={`lotNo`}
                            label="Lot No"
                            onChange={(e) =>
                              setFieldValue(`lotNo`, e.target.value)
                            }
                            value={values?.lotNo}
                            error={errors?.lotNo ? true : false}
                            helperText={errors?.lotNo ?? ""}
                          />
                        </Grid>
                      </Grid>
                    </div>

                    <Stack
                      spacing={{ xs: 1, sm: 2 }}
                      direction="row"
                      justifyContent="flex-end"
                      alignItems="flex-end"
                      sx={{ width: "100%" }}
                    >
                      <LoadingButton
                        variant="outlined"
                        color="secondary"
                        size="large"
                        onClick={() => {
                          closeEdit();
                        }}
                      >
                        Cancel
                      </LoadingButton>
                      <LoadingButton
                        type="submit"
                        variant="contained"
                        size="large"
                        loading={isSubmitting}
                      >
                        Update
                      </LoadingButton>
                    </Stack>
                  </Form>
                )}
              </Formik>
            }
            title={
              editActionProps?._id
                ? "Update Product Process"
                : "Update Product Process"
            }
            fullWidth={true}
            maxWidth={"md"}
            actions={<></>}
          />

          <DialogConfirm
            isOpen={isDelete}
            onClose={closeDelete}
            title="Are you sure you want to delete the product process?"
            onConfirm={DeleteProduct}
            btnLabels={{ cancel: "Cancel", confirm: "Delete" }}
          />
        </>
      )}
    </>
  );
};

export default ProductProcess;
